export default "assets/images/icons/arrow-btn-6f891b47.svg";